import { DataListService } from '../common/data/data-list.service';
import * as i0 from "@angular/core";
import * as i1 from "../common/auth/auth-api-http-client";
export class CustomerListService extends DataListService {
    constructor(httpClient) {
        super({
            httpClient,
            url: 'health/customers',
            initial: []
        });
    }
}
CustomerListService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CustomerListService_Factory() { return new CustomerListService(i0.ɵɵinject(i1.AuthApiHttpClient)); }, token: CustomerListService, providedIn: "root" });
